import styled from "styled-components";

export const StyledBackground = styled.div`
  height: ${(props: any) => props.height};
  width: ${(props: any) => props.width};
  background-image: url(${(props: any) => props.backgroundImageMobile});
  background-size: cover;
  position: ${(props: any) => props.position};
  top: 0;
  left: 0;
  z-index: 0;

  @media (min-width: 1024px) {
    background-image: url(${(props: any) => props.backgroundImageDesktop});
  }
` as any;
